import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { WarningPopUp, Image, Anchor } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import QuoteItems from "./QuoteItems";
import cancelIcon from "@icons/ic-cancel.svg";
import { renderPriceWithCurrencyWithoutUnit, addSpace } from "@utils/utils";
import { RequiredMessage } from "@utils/extra-style";

import {
  Title,
  FlexRowHeader,
  GridRow,
  ErrorDiv,
  QuoteInfoAndConditionsInfo,
  GridSubLabel,
} from "../../QuoteView.styled";

import {
  HeaderWrapperTable,
  EnquiryIdLink,
  MargingDiv,
  MarginGridSubItem,
  QuoteServiceInfo,
  QuoteServicePadding,
  ServiceInfo,
  GridItem,
  HeaderGridRow,
  ListTitle,
  ListSubTitle,
  ExchangeValueSpan,
  ExchangeUl,
} from "./QuoteServices.styled";

const QuoteServices = (props) => {
  const {
    t,
    data,
    currencyList,
    userCurrency,
    itemsErrorMessage,
    setQuoteData,
  } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [quoteServiceId, setQuoteServiceId] = useState();
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "QUOTE_SERVICE_CONFIRMATION_BOX_DISABLE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "QUOTE_SERVICE_CONFIRMATION_BOX_DISABLE_CONTENT"
  );

  const getConvertedPrice = (currencyId, price) => {
    const rateInfo = data?.exchangeRates.find(
      (rate) => rate.currencyFrom === currencyId
    );
    return rateInfo ? rateInfo?.exchangeRate * price : price;
  };

  const handleDisableAction = (id) => {
    setQuoteServiceId(id);
    setConfirmVisibility(true);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
    setQuoteServiceId();
  };

  const disableActionCheck = (items) => {
    let iconShow = 0;
    if (
      data?.site?.needKickoff === 1 &&
      items !== undefined &&
      items.length > 0
    ) {
      items.map((item) => {
        if (item.koStatus === 1) {
          iconShow += 1;
        }
      });
    }
    return items?.length === iconShow;
  };

  useEffect(() => {
    if (isConfirm) {
      const formStatus = "0";
      axios
        .post(
          `/quotes/${data.id}/services/${quoteServiceId}/updateStatus`,
          formStatus
        )
        .then((response) => {
          setQuoteData(response.data[0]);
          setQuoteServiceId();
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <>
      <FlexRowHeader>
        <Title>{t("QUOTE_SECTION_SERVICES")}</Title>
      </FlexRowHeader>
      <QuoteServiceInfo>
        <QuoteServicePadding>
          <HeaderGridRow
            column="60% 12% 13% 15%"
            marginBottom="0px"
            gridGap="0rem"
            marginTop="0px"
          >
            <GridItem padding="0px"> </GridItem>
            <GridItem fontSize="14px" fontWeight="700" padding="0px">
              {t("QUANTITY")}
            </GridItem>
            <GridItem fontSize="14px" fontWeight="700" padding="0px">
              {t("SELLING_PRICE_ITEM_PRICE")}
            </GridItem>
            <GridItem
              fontSize="14px"
              fontWeight="700"
              textAlign="right"
              borderRight="0px solid rgba(10, 73, 134, 0.3)"
              padding="0px 15px"
            >
              {t("SELLING_PRICE_ITEM_TOTAL")}
            </GridItem>
          </HeaderGridRow>

          {data?.services?.length > 0 &&
            data?.services.map((service, serviceIndex) => {
              return (
                <React.Fragment key={"quoteEnquiryService" + serviceIndex}>
                  <GridRow marginBottom="0px" marginTop="0px">
                    <HeaderWrapperTable
                      color={service?.isActive ? "#d1e6f7" : "#767676"}
                    >
                      <GridRow
                        column="auto 70% 1fr"
                        marginBottom="0px"
                        marginTop="0px"
                        gridGap=".5rem"
                      >
                        <Title marginTop="6px" fontWeight="bold">
                          <Anchor
                            url={`/site/view/${data?.site?.id}/enquiry-view-${service.sellingPrice.requestId}`}
                            target="_blank"
                            styles={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: service?.isActive ? "#0A4986" : "#fff",
                            }}
                          >
                            {t("ENQUIRY") +
                              " #" +
                              service?.sellingPrice?.requestId}
                          </Anchor>
                          <EnquiryIdLink
                            color={service?.isActive ? "#0A4986" : "#fff"}
                            decoration="none"
                          >
                            {" "}
                            -{" "}
                          </EnquiryIdLink>
                        </Title>
                        <GridSubLabel
                          fontSize="20px"
                          color={service?.isActive ? "#0A4986" : "#fff"}
                        >
                          {service?.label}
                        </GridSubLabel>
                        {parseInt(data.status, 10) === 3 &&
                          parseInt(service.isActive, 10) === 1 && (
                            <>
                              {(parseInt(data.site.needKickoff, 10) === 0 ||
                                disableActionCheck(service.items)) && (
                                <Image
                                  src={cancelIcon}
                                  className="quote_view__service-image-icon"
                                  onClick={() =>
                                    handleDisableAction(service.id)
                                  }
                                  alt={t("QUOTE_SERVICE_DISABLE_TOOLTIP")}
                                  title={t("QUOTE_SERVICE_DISABLE_TOOLTIP")}
                                />
                              )}
                            </>
                          )}
                      </GridRow>
                    </HeaderWrapperTable>
                  </GridRow>
                  <QuoteInfoAndConditionsInfo
                    marginBottom="20px"
                    padding="0px"
                    boxShadow="0px 0px 0px 0px rgba(0,76,127,0.25)"
                  >
                    <QuoteItems
                      enquiryId={service.sellingPrice.requestId}
                      sellingPriceId={service.sellingPriceId}
                      itemList={service.items}
                      currency={service?.currency}
                      getConvertedPrice={getConvertedPrice}
                      mainCurrency={data.currency}
                      serviceStatus={service?.isActive}
                    />
                  </QuoteInfoAndConditionsInfo>
                </React.Fragment>
              );
            })}
          {data?.services?.length === 0 && (
            <ServiceInfo color="#767676">{t("QUOTE_NO_SERVICES")}</ServiceInfo>
          )}
          {data?.services?.length === 0 && itemsErrorMessage && (
            <ErrorDiv>
              <RequiredMessage>
                <Image
                  src={errorIcon}
                  alt="warning"
                  styles={{ width: "18px", cursor: "pointer" }}
                />{" "}
                {itemsErrorMessage}
              </RequiredMessage>
            </ErrorDiv>
          )}
        </QuoteServicePadding>
        <MargingDiv>
          <GridRow column="60% 1fr" marginBottom="3px">
            <ExchangeUl>
              {data?.exchangeRates?.length > 0 &&
                data?.exchangeRates.map((exchange, exchangeIndex) => {
                  return (
                    <React.Fragment
                      key={"quoteservice-item-exchange-" + exchangeIndex}
                    >
                      {exchangeIndex === 0 && (
                        <ListTitle>{t("QUOTE_EXCHANGE_RATE")}</ListTitle>
                      )}
                      <ListSubTitle>
                        (
                        {currencyList[exchange.currencyFrom] +
                          " -> " +
                          userCurrency[data.currency.id]}
                        ) :{" "}
                        <ExchangeValueSpan>
                          {exchange.exchangeRate}
                        </ExchangeValueSpan>
                      </ListSubTitle>
                    </React.Fragment>
                  );
                })}
            </ExchangeUl>
            <div>
              <GridRow column="70% 1fr" marginBottom="3px">
                <MarginGridSubItem color="#0A4986">
                  {t("QUOTE_TOTAL_EXCLUDED_TAX")}
                </MarginGridSubItem>
                <MarginGridSubItem color="#474747">
                  {renderPriceWithCurrencyWithoutUnit(
                    addSpace(data?.totalExcludingTax),
                    data?.currency?.symbol,
                    data?.currency?.position
                  )}
                </MarginGridSubItem>
              </GridRow>
              <GridRow column="70% 1fr" marginBottom="3px">
                <MarginGridSubItem color="#0A4986">
                  {t("QUOTE_PDF_TAXES")} ({data?.taxRate?.label})
                </MarginGridSubItem>
                <MarginGridSubItem color="#474747">
                  {renderPriceWithCurrencyWithoutUnit(
                    addSpace(data?.totalIncludingTax),
                    data?.currency?.symbol,
                    data?.currency?.position
                  )}
                </MarginGridSubItem>
              </GridRow>
              <GridRow column="70% 1fr" marginBottom="3px">
                <MarginGridSubItem color="#0A4986">
                  {t("QUOTE_TOTAL_MARGIN")}
                </MarginGridSubItem>

                <MarginGridSubItem color="#474747">
                  ({data?.totalMargin + "%"}){" "}
                  {renderPriceWithCurrencyWithoutUnit(
                    data?.totalMarginValue
                      ? addSpace(data?.totalMarginValue)
                      : "0.00",
                    data?.currency?.symbol,
                    data?.currency?.position
                  )}
                </MarginGridSubItem>
              </GridRow>
            </div>
          </GridRow>
        </MargingDiv>
      </QuoteServiceInfo>
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent="VALIDATE"
          CancelContent="CANCEL"
        />
      )}
    </>
  );
};

QuoteServices.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(QuoteServices);
